import { useTranslation } from 'react-i18next';
import { DataPillGradientLegend } from './DataPillGradientLegend';

export const PercentileDataPillLegend = () => {
  const { t } = useTranslation('radar');
  return <DataPillGradientLegend title={t('legend.percentileColouring')} />;
};
